var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{class:[
    'taxation-status fs-14',
    _vm.ndsStatusConfig[_vm.status || 'not_stated'].color ]},[_vm._v("\n  "+_vm._s(_vm.ndsStatusConfig[_vm.status || 'not_stated'].text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }